'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isExpanded", "heading", "children"];
import React, { useContext } from 'react';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { Type } from "../Type/index.mjs";
import { AccordionIcon } from "./Icon.mjs";
import { Title } from "./Title.mjs";
import { TitleText } from "./TitleText.mjs";
export var AccordionTitle = /*#__PURE__*/React.forwardRef(function AccordionTitle(_ref, ref) {
  var _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? 'h2' : _ref$heading,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  return /*#__PURE__*/React.createElement(Type, {
    as: heading,
    ref: ref
  }, /*#__PURE__*/React.createElement(Title, Object.assign({
    isUsingKeyboard: isUsingKeyboard,
    useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    "aria-expanded": isExpanded
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.AccordionTitle
  }), /*#__PURE__*/React.createElement(TitleText, {
    variant: "celloCanon"
  }, children), /*#__PURE__*/React.createElement(AccordionIcon, {
    $isExpanded: isExpanded,
    semanticColor: "textSubdued",
    "aria-hidden": "true",
    role: "presentation"
  })));
});